export default {
  DEFAULT_NAMESPACE: 'Default',
} as const;
